enum DataTypes {
  cost,
  effort,
  material,
}

export default DataTypes;
